import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import KVKK from "../pages/KVKK";
import AccountDeletion from "../pages/AccountDeletion";
import SSS from "../pages/SSS";
import Esnaf from "../pages/Esnaf";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/kvkk",
    element: <KVKK />,
  },
  {
    path: "/account-deletion",
    element: <AccountDeletion />,
  },
  {
    path: "/sss",
    element: <SSS />,
  },
  {
    path: "/esnaf",
    element: <Esnaf />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
